import { FormField } from '@workspace/ui/components/form-field'
import { TextInput } from '@workspace/ui/components/text-input'
import { CheckboxGroup, PersonalInfoSection, TagsInput } from './confirm-form-fields'
import type { InvestorFormData, InvestorProfileInfo } from './confirm-form-utils'

interface InvestorConfirmFormProps {
  data: InvestorFormData
  disabled?: boolean
  investmentAreaOptions: { value: string; label: string }[]
  investmentRegionOptions: { value: string; label: string }[]
  onChange: (data: InvestorFormData) => void
}

export function InvestorConfirmForm({
  data,
  disabled,
  investmentAreaOptions,
  investmentRegionOptions,
  onChange,
}: InvestorConfirmFormProps) {
  const setPersonal = (personal: InvestorFormData['personal']) => {
    onChange({ ...data, personal })
  }

  const setProfile = (field: keyof InvestorProfileInfo, value: string) => {
    onChange({ ...data, profile: { ...data.profile, [field]: value } })
  }

  return (
    <>
      <PersonalInfoSection data={data.personal} disabled={disabled} onChange={setPersonal} />

      <div className="p-4">
        <h4 className="mb-2.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          Investment Profile
        </h4>
        <div className="space-y-3">
          <FormField label="Fund Name">
            <TextInput
              inputSize="sm"
              value={data.profile.fundName}
              onChange={(e) => setProfile('fundName', e.target.value)}
              disabled={disabled}
            />
          </FormField>

          <FormField label="Fund Website">
            <TextInput
              inputSize="sm"
              value={data.profile.fundWebsite}
              onChange={(e) => setProfile('fundWebsite', e.target.value)}
              disabled={disabled}
            />
          </FormField>

          <FormField label="Investment Areas">
            <TagsInput
              value={data.profile.investmentAreas}
              onChange={(v) => setProfile('investmentAreas', v)}
              suggestions={investmentAreaOptions.map((o) => o.label)}
            />
          </FormField>

          <FormField label="Investment Regions">
            <CheckboxGroup
              value={data.profile.investmentRegions}
              onChange={(v) => setProfile('investmentRegions', v)}
              options={investmentRegionOptions}
            />
          </FormField>
        </div>
      </div>
    </>
  )
}
